import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Spinner, Table } from 'react-bootstrap'; 
import downloadIcon from '../../assets/images/Blue/download.svg';
import * as models from '../../models';
import editIcon from '../../assets/images/Blue/edit.svg'; 
import SingleActionButton from 'components/common/SingleActionButton';
import * as router from '../../services/router-service'; 
import { companyActions } from 'store/companies';
import { PhoneNumberType } from 'models/contacts/phoneNumber';

interface Props extends PropsFromRedux {}

class CompanyTable extends React.Component<Props> {

    public editCompany = (companyId: number) => {
        router.goto(router.url.companyDetail.replace(":companyId", companyId.toString())); 
    }

    public exportCompanies = async () => {
        const exportQuery: models.CompaniesRequest = {
            ...this.props.companyListRequest,
            pageNo: 1,
            pageSize: this.props.companyListResponse.totalCount,
        }
        await this.props.requestCompanyCSV(exportQuery); 
    }

    private formatPhoneNumber = (phone: string | undefined) => {
        if (!phone) return '';
        const cleaned = ('' + phone).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phone;
    }

    public render() {
        const { companyListResponse, isCompaniesDownloading, isLoading } = this.props;        
        const runSpinner = isCompaniesDownloading || isLoading;

        return (
            <Card className="claim-card">
                <Card.Title>Companies
                    {runSpinner && <span>&nbsp;{isCompaniesDownloading ? "Exporting..." : "Loading..."}&nbsp;&nbsp;<Spinner animation="border" role="status" variant="primary" size="sm"/></span>}
                    <SingleActionButton
                            action="Export"
                            title="Companies"
                            img={downloadIcon}
                            onClick={this.exportCompanies}
                            disabled={isCompaniesDownloading}
                        />
                </Card.Title>
            {companyListResponse.totalCount > 0 &&
                <Table striped hover responsive>
                    <thead>
                        <tr>                                                    
                            <th>Active</th> 
                            <th>Company Name</th>                                                                                                                           
                            <th>Type</th>
                            <th>Business Phone</th> 
                            <th>Email</th>
                            <th>Claim Email</th>
                            <th>Assigned Rep</th>
                            {/* Metric Columns */}
                            <th className="text-center">Active Claims</th>
                            <th className="text-center">YTD Open</th>
                            <th className="text-center">YTD Closed</th>                     
                            <th className="text-center">Lifetime Claims</th>                     
                            <th className="text-center">Last Claim</th>                     
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {companyListResponse.resourceList && companyListResponse.resourceList.map((x: models.CompanySummary, i: number) => {
                        const businessPhone = x.phoneNumbers?.find(p => p.phoneNumberType === PhoneNumberType.Business)?.phoneNumber;

                        return (
                        <tr key={i}>            
                            <td>{x.isActive ? "Yes" : "No"}</td>
                            <td>{x.name}</td>
                            <td>{x.type}</td>                            
                            
                            {/* Formatted Phone Number */}
                            <td style={{whiteSpace: 'nowrap'}}>
                                {this.formatPhoneNumber(businessPhone)}
                            </td>

                            <td>{x.email}</td>
                            <td>{x.claimEmail}</td>
                            <td>{x.assignedRep}</td>
                            
                            {/* Metrics with formatting */}
                            <td className="text-center font-weight-bold">{x.activeClaimCount?.toLocaleString() || 0}</td>
                            <td className="text-center">{x.ytdOpenClaims?.toLocaleString() || 0}</td>              
                            <td className="text-center">{x.ytdClosedClaims?.toLocaleString() || 0}</td>              
                            <td className="text-center">{x.lifetimeClaimCount?.toLocaleString() || 0}</td>              
                            <td className="text-center">
                                {x.lastClaimDate ? new Date(x.lastClaimDate).toLocaleDateString() : '-'}
                            </td>              
                            
                            <td className="text-right">
                                <SingleActionButton
                                    action="Edit"
                                    title={"Company"}
                                    img={editIcon}
                                    onClick={() => this.editCompany(x.companyId)}
                                />
                            </td>
                        </tr>
                        );
                    })}
                    </tbody>
                </Table>
            }
            {companyListResponse.totalCount === 0 && !runSpinner &&
                <div className="p-3 text-center text-muted">No companies found.</div>
            }
            </Card>
        );
    }
}
const mapStateToProps = (state: MyTypes.RootState) => ({
    companyListResponse: state.companies.company.companiesResponse,
    companyListRequest: state.companies.company.companiesRequest,
    isLoading: state.companies.company.isCompanyListLoading,
    isCompaniesDownloading: state.companies.company.isCompanyListDownloading,    
}); 

const mapDispatchToProps = (dispatch: Dispatch) => 
    bindActionCreators(
        {        
            requestCompanyCSV: companyActions.requestCompanyCSV
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(CompanyTable);